
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface AddReviewButtonProps {
  companyName: string;
}

/**
 * AddReviewButton that handles navigation to the review form
 * Authentication checks are handled by the protected route
 */
const AddReviewButton: React.FC<AddReviewButtonProps> = ({ companyName }) => {
  const navigate = useNavigate();
  
  const handleAddReview = () => {
    console.log("Add Review button clicked, navigating to review form for:", companyName);
    // Include the full path to ensure accurate redirect after authentication
    navigate(`/add-review?company=${encodeURIComponent(companyName)}`);
  };
  
  return (
    <div>
      <Button 
        onClick={handleAddReview}
        className="bg-redflags-red hover:bg-redflags-red/90 text-white"
      >
        Add a review
      </Button>
    </div>
  );
};

export default AddReviewButton;
